module.exports = __webpack_public_path__ + "static/media/delte.0ec67604.png";